var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "488" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        {
          staticClass: "modalHead",
          staticStyle: { "border-bottom": "0" },
          attrs: { slot: "header" },
          slot: "header",
        },
        [_c("span", [_vm._v(_vm._s(_vm.modalheader))])]
      ),
      _c("div", { staticClass: "modalContent" }, [
        _c("p", [_vm._v(_vm._s(_vm.modalcontent))]),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "pp-btn pp-btn-primary pp-btn-spec",
              on: { click: _vm.skipeTo },
            },
            [_vm._v(_vm._s(_vm.modalbtn))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }